import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  registerField,
  change,
  getFormSyncErrors,
  getFormMeta,
  touch,
} from 'redux-form';
import { Button, Form } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

class ReduxFormButtonGroup extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    formName: PropTypes.string.isRequired,
    fieldName: PropTypes.string.isRequired,
    options: PropTypes.arrayOf(
      PropTypes.shape({
        label: PropTypes.string.isRequired,
        value: PropTypes.oneOfType([
          PropTypes.bool,
          PropTypes.string,
          PropTypes.number,
        ]),
      })
    ),
    unsettable: PropTypes.bool,
    fluid: PropTypes.bool,
    showOnlyTouchedError: PropTypes.bool,
  };

  static defaultProps = {
    unsettable: false,
    onChange: value => {},
    fluid: false,
    showOnlyTouchedError: false,
  };

  componentDidMount() {
    const { formName, fieldName } = this.props;
    this.props.dispatch(registerField(formName, fieldName, 'Field'));
  }

  handleChange = (e, value) => {
    e.preventDefault();

    const { formName, fieldName, value: setValue, unsettable } = this.props;

    if (unsettable && value === setValue) {
      this.props.dispatch(change(formName, fieldName, null));
    } else {
      this.props.dispatch(change(formName, fieldName, value));
    }
    this.props.dispatch(touch(formName, fieldName));
    this.props.onChange(value);
  };

  render() {
    const {
      options,
      value,
      label,
      error,
      touched,
      className,
      disabled,
      type,
      fluid,
      showOnlyTouchedError,
    } = this.props;
    const displayLabel = label != null && label.length > 0;
    const errorClassName = classnames('input--message', {
      'input--message-error': touched && error,
      error: touched && error,
      'input--message-empty': !touched,
    });
    const labelClassName = classnames({ error: touched && error });

    return (
      <Form.Field>
        {displayLabel && <label className={labelClassName}>{label}</label>}
        <Button.Group
          basic
          className={`${className} btn-group--active-group`}
          fluid={fluid}
        >
          {options.map((option, i) => {
            return (
              <Button
                basic
                active={value === option.value}
                className="white"
                disabled={option.disabled || disabled}
                key={i}
                type={type}
                onClick={e => {
                  this.handleChange(e, option.value);
                }}
              >
                {option.label}
              </Button>
            );
          })}
        </Button.Group>
        {showOnlyTouchedError
          ? touched && error && <span className={errorClassName}>{error}</span>
          : error && <span className={errorClassName}>{error}</span>}
      </Form.Field>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { formName, fieldName } = ownProps;
  const error = getFormSyncErrors(formName)(state);
  const meta = getFormMeta(formName)(state);

  return {
    value: ownProps.value
      ? ownProps.value
      : state.form[formName] && state.form[formName].values
      ? state.form[formName].values[fieldName]
      : null,
    error: error ? error[fieldName] : null,
    touched: meta && meta[fieldName] ? meta[fieldName].touched : false,
  };
};

ReduxFormButtonGroup = connect(mapStateToProps)(ReduxFormButtonGroup);

export { ReduxFormButtonGroup };



// WEBPACK FOOTER //
// ./src/components/forms/ReduxFormButtonGroup.js